import DOMPurify from "dompurify"

export function sanitize(value: string) {
  return DOMPurify.sanitize(value, { ADD_ATTR: ['target'] })
}